// Fire-and-forget error beacon for remote login-flow diagnosis.
// Never throws; best-effort POST to the server's client-errors ring buffer.
export function beacon(kind: string, err: any) {
  try {
    const message = err instanceof Error ? `${err.name}: ${err.message}` : String(err?.message || err || 'unknown');
    const stack = err instanceof Error ? (err.stack || '').slice(0, 400) : err?.code ? `code=${err.code}` : '';
    const payload = JSON.stringify({
      kind: String(kind).slice(0, 40),
      message: message.slice(0, 400),
      stack,
      userAgent: navigator.userAgent.slice(0, 120),
      path: location.pathname + location.hash,
    });
    // keepalive so it survives page transitions
    fetch('/api/client-errors', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
  } catch { /* never break the app for diagnostics */ }
}
